module.exports = {
      id: "ic-home-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-2c53a1.smartcharts.svg#ic-home-usage",
      toString: function () {
        return this.url;
      }
    }